import Messages from "../../../localization/Messages";

export const statsLDExpensePerShipColumnDefs = [
    Messages.from,
    Messages.to,
    Messages.vesselName,
    Messages.eni,
    Messages.mmsiShort,
    Messages.managingCompany,
    Messages.owningCompany,
    Messages.arrivalDaysTotal,
    Messages.totalCostsArrivalDays,
    Messages.layDaysTotal,
    Messages.totalCostsLayDays,
    Messages.totalElectricityAmount,
    Messages.totalCostsElectricity,
    Messages.totalWaterAmount,
    Messages.totalCostsWater,
    Messages.numberOfWasteDisposalServices,
    Messages.totalCostsWasteDisposal,
    Messages.numberServicesSaturday,
    Messages.numberServicesNightSundayHolidays,
    Messages.totalCostsServices,
    Messages.totalCostsWayfee,
    Messages.bedsTotal,
    Messages.totalCosts,
    Messages.totalDays,
    // TODO: Dock1, Dock2, Dock3 columns - these need to be added to the API response
];

export const statsExpensePerShipColumnDefs = [
    Messages.from,
    Messages.to,
    Messages.vesselName,
    Messages.eni,
    Messages.mmsiShort,
    Messages.managingCompany,
    Messages.owningCompany,
    Messages.beds,
    Messages.length,

    Messages.electricityCardNumber,
    Messages.statusElectricityCardNumber,

    Messages.keyNumber,
    Messages.statusKeyNumber,

    Messages.arrivalDaysTotal,
    Messages.totalCostsArrivalDays,

    Messages.layDaysTotal,
    Messages.totalCostsLayDays,

    Messages.totalElectricityAmount,
    Messages.totalCostsElectricity,

    Messages.totalWaterAmount,
    Messages.totalCostsWater,

    Messages.numberOfWasteDisposalServices,
    Messages.totalCostsWasteDisposal,

    Messages.numberServicesSaturday,
    Messages.numberServicesSunday,

    Messages.totalCostsServices,
    Messages.totalCostsWayfee,

    Messages.bedsTotal,
    Messages.totalDays,
    Messages.totalCosts,
];

export const statsPerDockColumnDefs = [
    Messages.from,
    Messages.to,
    Messages.dockName,

    Messages.berthingsLte110,
    Messages.berthingsGt110,
    Messages.beds,

    Messages.arrivalDaysTotal,
    Messages.totalCostsArrivalDays,

    Messages.layDaysTotal,
    Messages.totalCostsLayDays,

    Messages.totalElectricityAmount,
    Messages.totalCostsElectricity,

    Messages.totalWaterAmount,
    Messages.totalCostsWater,

    Messages.numberOfWasteDisposalServices,
    Messages.totalCostsWasteDisposal,

    Messages.numberServicesSaturday,
    Messages.numberServicesSunday,

    Messages.totalCostsServices,
    Messages.totalCostsWayfee,

    Messages.totalDays,
    Messages.totalCosts,
];

export const statsPerShipAndDockColumnDefs = [
    Messages.from,
    Messages.to,
    Messages.destination,
    Messages.dockName,
    Messages.vesselName,
    Messages.managingCompany,
    Messages.owningCompany,
    Messages.arrivalDaysTotal,
    Messages.layDaysTotal,
    Messages.totalDays,
];
